import React from 'react';
import Card from '../../components/common/Card';

const DevolucionForm = () => {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-gray-800">Nueva Devolución</h1>
      <Card>
        <p className="text-center text-gray-500 py-8">
          Formulario de Devolución - En desarrollo
        </p>
      </Card>
    </div>
  );
};

export default DevolucionForm;